import HomePage from "../Layouts/HomePage";
import About from "../Pages/About/About";
import Blog from "../Pages/Blog/Blog";
import Contact from "../Pages/Contact/Contact";
import Home from "../Pages/Home/Home/Home";
import ProjectCaseStudy from "../Pages/Home/Projects/ProjectCaseStudy";

const { createBrowserRouter } = require("react-router-dom");

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage></HomePage>,
    children: [
      {
        path: "/",
        element: <Home></Home>,
      },
      {
        path: "/contact",
        element: <Contact></Contact>,
      },
      {
        path: "/blog",
        element: <Blog></Blog>,
      },
      {
        path: "/about",
        element: <About></About>,
      },
      {
        path: "/projects/:id",
        element: <ProjectCaseStudy></ProjectCaseStudy>,
        loader: ({ params }) =>
          fetch(
            `https://portfolio-farhan-hasin-dipro-v2-server.vercel.app/projects/${params.id}`
          ),
      },
    ],
  },
]);

export default router;
